import classNames from 'classnames';
import * as PropTypes from 'prop-types';
import React from 'react';

import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

interface WarningIconProps {
  className?: string;
}

function WarningIcon({className}: WarningIconProps): JSX.Element {
  return <BenchlingIcon icon="warning" className={classNames('u-dark-warning-color', className)} />;
}

WarningIcon.propTypes = {
  className: PropTypes.string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
} as any;

export default WarningIcon;
